// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class NotificationPushDeviceResource extends Resource {
    basePath: string = 'notifications/push-devices';

    objectPath: string = 'notifications/push-devices/{ident}/';
}
